<template>
  <div>
    <Row>
      <!-- 手机端 -->
      <Col :xs="{ span: 24 }" :lg="{ span: 0 }">
          <!-- 上轮播 -->
          <div>
            <Carousel v-model="slideIndex" :autoplay='true' :autoplay-speed='3500' :radius-dot="true" >
              <CarouselItem v-for="(item,index) in carouselTop" :key="`index${index}`">
                <img @click="slideClick(item)" :src="`http://assets.jzyxxb.cn/${item.url}`" alt="轮播图" class="lunbo_img_app">
              </CarouselItem>
            </Carousel>
          </div>
          <!-- 5个分类 -->
          <div v-for="(item,index) in fenleiList" style="width:94%;margin-left:3%;margin-bottom:10px;">
              <div style="display:flex;justify-content:space-between; ">
                  <div class="con">
                    <div style="width:100%;text-align:left;padding-right:15px;">
                      <img src="../assets/image/top.png" class="topImg">
                      {{item.Lanmu}}
                    </div>
                  </div>
                  <div @click="goMenuList(item.LanmuId)" class="gengduo" style="margin-right:0px">更多>></div>
              </div>
              <div>
                <Row class="titleContainer-app" v-for="(li,index2) in item.Article" :key="`list${index2}`"  v-if="index2<6">
                  <div @click="goDetail(li.article_id,item.LanmuId)">
                      <Col :xs="{ span: 18 }" :md="{ span: 14 }" :lg="{ span: 18 }" class="title">
                        <div style="display:flex;">
                          <div style="width:4px;height:4px;background-color:#165b92;margin:9px 6px 0 0"></div>
                          <div v-if="li.is_tuijian!=1 && li.is_img!=1&&li.is_ding<=0">
                              <div v-if="li.is_qiang ==1" style="color:#ff0000;font-weight:bold">{{li.title}}</div>
                              <div v-else>{{li.title}}</div>
                          </div>
                          <div>
                              <div v-if="li.is_qiang ==1" style="color:#ff0000;font-weight:bold">{{li.title}}</div>
                              <div v-else>{{li.title}}</div>
                          </div>
                          <div style="color:#ff0000;font-size:14px;display:flex;font-weight:normal">
                            <div v-if="li.is_tuijian==1">【荐】</div>
                            <div v-if="li.is_img==1">【图】</div>
                            <div v-if="li.is_ding>0">【顶】</div>
                          </div>
                        </div>
                      </Col>
                      <Col :xs="{ span: 6 }" :md="{ span: 10 }" :lg="{ span: 6 }" class="tileTime">{{li.create_time | time}}</Col>
                  </div>
                </Row>
              </div>
          </div>
          <!-- 热点推荐 -->
          <div style="width:94%;margin-left:3%;margin-bottom:20px;margin-top:5px;">
              <div style="display:flex;justify-content:space-between; ">
                  <div class="con">
                    <div style="width:100%;text-align:left;padding-right:15px;">
                      <img src="../assets/image/top.png" class="topImg">
                      热点推荐
                    </div>
                  </div>
                  <div></div>
              </div>
              <div class="lineSty"></div>
              <Row v-for="(li,index) in redianList" :title="li.title" class="titleContainer-app" v-if="index<4" :key="`list${index}`">
                <div @click="goDetail2(li.article_id)">
                    <Col :xs="{ span: 18 }" :md="{ span: 14 }" :lg="{ span: 18 }" class="title">
                      <div style="display:flex;">
                        <div style="width:4px;height:4px;background-color:#165b92;margin:8px 6px 0 0"></div>
                        {{li.title}}
                      </div>
                    </Col>
                    <Col :xs="{ span: 6 }" :md="{ span: 10 }" :lg="{ span: 6 }" class="tileTime">{{li.create_time | time}}</Col>
                </div>
              </Row>
          </div>
          <!-- 快速通道 -->
          <div style="margin:22px 0 13px 0;">
            <div style="padding-bottom: 5px;color: #165b92;font-weight: bold;font-size:16px;margin: 12px 0 0 15px;">
              <img src="../assets/image/top.png" class="topImg">
              快速通道
            </div>
            <div style="border-top: solid #E8E8E8 1px;width: 100%;margin: 0px 0 13px 0;"></div>
            <!-- 快速通道按钮 -->
            <Row :gutter="30" style="width: 96%;margin-left:2%">
              <Col span="12" v-for="(item,index) in kuaisuList" class="exprssCon-app" >
                <div class="exprss-app" @click="goFast(item)"> {{item.name}}</div>
              </Col>
            </Row>
          </div>
      </Col>
      <!-- 电脑端 -->
      <Col :xs="{ span: 0 }" :lg="{ span: 24 }">
        <Col :xs="{ span: 24 }" :lg="{ span: 18 ,offset:3}">
          <!-- 上轮播 -->
          <div>
            <Carousel v-model="slideIndex" :autoplay='true' :autoplay-speed='3500' :radius-dot="true" >
              <CarouselItem v-for="(item,index) in carouselTop" :key="`index${index}`">
                <img @click="slideClick(item)" :src="`http://assets.jzyxxb.cn/${item.url}`" alt="轮播图" class="lunbo_img">
              </CarouselItem>
            </Carousel>
          </div>
          <div style="display:flex;margin-top:2px">
              <!-- 左 -->
              <div style="width:70%;margin-right:18px;background:#fff;">
                <!-- 左1tab切换 -->
                <div style="height:270px;display:flex;">
                  <div style="width:50%;" v-for="(item,index) in list1">
                      <div style="display:flex;justify-content:space-between; ">
                          <div class="con">
                            <div>
                              <img src="../assets/image/top.png" class="topImg">
                              {{fontNumber(item.Lanmu,16)}}
                            </div>
                          </div>
                          <div @click="goMenuList(item.LanmuId)" class="gengduo">更多>></div>
                      </div>
                      <div class="lineSty"></div>
                      <div style="width: 93%;margin-left:3.5%">
                        <Row class="titleContainer" v-for="(li,index2) in item.Article" :key="`list${index2}`"  v-if="index2<6">
                          <div @click="goDetail(li.article_id,item.LanmuId)" @mouseenter='change_list(index2,index)'>
                              <Col :xs="{ span: 18 }" :md="{ span: 14 }" :lg="{ span: 19 }" class="title">
                                <div v-if="index==0">
                                  <div v-if="cindex_list===index2" class="big_circle"></div>
                                  <div v-else class="small_circle"></div>
                                </div>
                                <div v-if="index==1">
                                  <div v-if="cindex_list2===index2" class="big_circle"></div>
                                  <div v-else class="small_circle"></div>
                                </div>
                                <div style="display:flex;overflow:hidden;">
                                  <Poptip trigger="hover">
                                    <div v-if="li.is_tuijian!=1 && li.is_img!=1&&li.is_ding<=0">
                                        <div v-if="li.is_qiang ==1" style="color:#ff0000;font-weight:bold">{{fontNumber(li.title,23)}}</div>
                                        <div v-else>{{fontNumber(li.title,23)}}</div>
                                    </div>
                                    <div v-else>
                                        <div v-if="li.is_qiang ==1" style="color:#ff0000;font-weight:bold">{{fontNumber(li.title,23)}}</div>
                                        <div v-else>{{fontNumber(li.title,23)}}</div>
                                    </div>
                                    <div class="api" slot="content" style="color:#c70000">
                                        {{li.title}}
                                    </div>
                                  </Poptip>
                                  <div style="color:#ff0000;font-size:14px;display:flex;font-weight:normal">
                                    <div v-if="li.is_tuijian==1" style="margin-left:2px;">[荐]</div>
                                    <div v-if="li.is_img==1" style="margin-left:2px;">[图]</div>
                                    <div v-if="li.is_ding>0" style="margin-left:2px;">[顶]</div>
                                  </div>
                                </div>
                              </Col>
                              <Col :xs="{ span: 6 }" :md="{ span: 10 }" :lg="{ span: 5 }" class="tileTime">{{li.create_time | time}}</Col>
                          </div>
                        </Row>
                      </div>
                  </div>
                </div> 
                <!-- 左2tab切换 -->
                <div style="height:270px;display:flex;">
                  <div style="width:50%;" v-for="(item,index) in list2">
                      <div style="display:flex;justify-content:space-between; ">
                          <div class="con">
                            <div>
                              <img src="../assets/image/top.png" class="topImg">
                              {{fontNumber(item.Lanmu,16)}}
                            </div>
                          </div>
                          <div @click="goMenuList(item.LanmuId)" class="gengduo">更多>></div>
                      </div>
                      <div class="lineSty"></div>
                      <div style="width: 93%;margin-left:3.5%">
                        <Row id="titleContainer" class="titleContainer" v-for="(li,index2) in item.Article" :key="`list${index2}`" v-if="index2<6">
                          <div @click="goDetail(li.article_id,item.LanmuId)" @mouseenter='change_list2(index2,index)'>
                              <Col :xs="{ span: 18 }" :md="{ span: 14 }" :lg="{ span: 19 }" class="title">
                                <div v-if="index==0">
                                  <div v-if="cindex_list3===index2" class="big_circle"></div>
                                  <div v-else class="small_circle"></div>
                                </div>
                                <div v-if="index==1">
                                  <div v-if="cindex_list4===index2" class="big_circle"></div>
                                  <div v-else class="small_circle"></div>
                                </div>
                                <div style="display:flex;overflow:hidden;">
                                  <Poptip trigger="hover">
                                    <div v-if="li.is_tuijian!=1 && li.is_img!=1&&li.is_ding<=0">
                                        <div v-if="li.is_qiang ==1" style="color:#ff0000;font-weight:bold">{{fontNumber(li.title,23)}}</div>
                                        <div v-else>{{fontNumber(li.title,23)}}</div>
                                    </div>
                                    <div v-else>
                                        <div v-if="li.is_qiang ==1" style="color:#ff0000;font-weight:bold">{{fontNumber(li.title,23)}}</div>
                                        <div v-else>{{fontNumber(li.title,23)}}</div>
                                    </div>
                                    <div class="api" slot="content" style="color:#c70000">
                                        {{li.title}}
                                    </div>
                                  </Poptip>
                                  <div style="color:#ff0000;font-size:14px;display:flex;font-weight:normal">
                                    <div v-if="li.is_tuijian==1" style="margin-left:2px;">[荐]</div>
                                    <div v-if="li.is_img==1" style="margin-left:2px;">[图]</div>
                                    <div v-if="li.is_ding>0" style="margin-left:2px;">[顶]</div>
                                  </div>
                                </div>
                              </Col>
                              <Col :xs="{ span: 6 }" :md="{ span: 10 }" :lg="{ span: 5 }" class="tileTime">{{li.create_time | time}}</Col>
                          </div>
                        </Row>
                      </div>
                  </div>
                </div>  
              </div>
              <!-- 右 -->
              <div style="width:30%;background:#fff;">
                <!-- 快速通道 -->
                <div style="height:270px;">
                  <div style="padding-bottom: 5px;color: #165b92;font-weight: bold;font-size:16px;margin: 12px 0 0 20px;">
                    <img src="../assets/image/top.png" class="topImg">
                    快速通道
                  </div>
                  <div class="lineSty"></div>
                  <!-- 快速通道按钮 -->
                  <Row :gutter="30" style="width: 95%;margin-left:2.5%">
                    <Col span="12" v-for="(item,index) in kuaisuList" class="exprssCon">
                      <div class="exprss" @click="goFast(item)"> {{item.name}}</div>
                    </Col>
                  </Row>
                </div>
                <!-- 列表3 -->
                <div style="height:270px;" v-for="(item,index) in list3">
                  <div style="display:flex;justify-content:space-between;margin-top:-11px; ">
                      <div class="con">
                        <div>
                          <img src="../assets/image/top.png" class="topImg">
                          {{fontNumber(item.Lanmu,13)}}
                        </div>
                      </div>
                      <div @click="goMenuList(item.LanmuId)" class="gengduo">更多>></div>
                  </div>
                  <div class="lineSty"></div>
                  <Row :title="li.title" class="titleContainer" v-for="(li,index2) in item.Article" v-if="index2<6" :key="`list${index2}`" style="width:92%;margin-left:4%">
                    <div @click="goDetail(li.article_id,item.LanmuId)" @mouseenter='change_list3(index2,index)'>
                        <Col :xs="{ span: 18 }" :md="{ span: 14 }" :lg="{ span: 18 }" class="title">
                          <div v-if="index==0">
                            <div v-if="cindex_list5===index2" class="big_circle"></div>
                            <div v-else class="small_circle"></div>
                          </div>
                          <div style="display:flex;">
                            <Poptip trigger="hover">
                              <div v-if="li.is_tuijian!=1 && li.is_img!=1&&li.is_ding<=0">
                                  <div v-if="li.is_qiang ==1" style="color:#ff0000;font-weight:bold">{{fontNumber(li.title,16)}}</div>
                                  <div v-else>{{fontNumber(li.title,16)}}</div>
                              </div>
                              <div v-else>
                                  <div v-if="li.is_qiang ==1" style="color:#ff0000;font-weight:bold">{{fontNumber(li.title,16)}}</div>
                                  <div v-else>{{fontNumber(li.title,16)}}</div>
                              </div>
                              <div class="api" slot="content" style="color:#c70000">
                                  {{li.title}}
                              </div>
                            </Poptip>
                            <div style="color:#ff0000;font-size:14px;display:flex;font-weight:normal">
                              <div v-if="li.is_tuijian==1">[荐]</div>
                              <div v-if="li.is_img==1">[图]</div>
                              <div v-if="li.is_ding>0">[顶]</div>
                            </div>
                          </div>
                        </Col>
                        <Col :xs="{ span: 6 }" :md="{ span: 10 }" :lg="{ span: 6 }" class="tileTime">{{li.create_time | time}}</Col>
                    </div>
                  </Row>
                </div>
              </div>
          </div>
        </Col>
      </Col> 
      <!-- 沁中风采 -->
      <div v-if="pingmuWidth>1000"  style="width:75%;margin-left:12.5%;">
        <div style="padding-bottom: 5px;color: #165b92;font-weight: bold;font-size:16px;margin: 0 0 0 15px;">
          <img src="../assets/image/top.png" class="topImg">
          沁中风采
        </div>
        <div style="border-top: solid #E8E8E8 1px;width: 100%;margin: 0px 0 10px 0;"></div>
        <!-- 底部跑马灯 -->
        <div class="roll" id="roll">
          <div style="overflow:hidden; padding-bottom:180px;position:relative;">
            <ul style="position:absolute;">
              <li v-for="(item,index) in carouseBottom" :key="`img${index}`" style="float: left;width:200px; list-style:none;cursor:pointer">
                <img @click="slideClick(item)" :src="`http://assets.jzyxxb.cn/${item.url}`" style="width:200px;height:150px;border:solid 1px #ffffff;">
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div v-else>
        <div style="padding-bottom: 5px;color: #165b92;font-weight: bold;font-size:16px;margin: 0 0 0 15px;">
          <img src="../assets/image/top.png" class="topImg">
          沁中风采
        </div>
        <div style="border-top: solid #E8E8E8 1px;width: 100%;margin: 0px 0 10px 0;"></div>
        <!-- 底部跑马灯 -->
        <div class="roll" id="roll">
          <div style="overflow:hidden; padding-bottom:180px;position:relative;">
            <ul style="position:absolute;">
              <li v-for="(item,index) in carouseBottom" :key="`img${index}`" style="float: left;width:200px; list-style:none;cursor:pointer">
                <img @click="slideClick(item)" :src="`http://assets.jzyxxb.cn/${item.url}`" style="width:200px;height:150px;border:solid 1px #ffffff;">
              </li>
            </ul>
          </div>
        </div>
      </div>
    </Row>
    <!-- 发布中，请稍等 -->
    <Spin size="large" fix v-if="spinShow">
        <div class="loader">
            <Icon type="ios-loading" size=80 class="demo-spin-icon-load"></Icon>
            <div>加载中</div>
        </div>
    </Spin>   
  </div>
  </div>
</template>
<script>
import {xxShouYeArticle,xxShouYeLunBo,xxFastChannel,redianArticleList } from '@/api/index'
import {goCarousel} from '@/libs/index'
export default {
  name: 'Home',
  data(){
    return{
      spinShow:false,
      slideIndex: 0,//幻灯片图片索引
      carouselTop:[],//上轮播图
      carouseBottom:[],//下轮播图
      list1:[],//上边两个文章分类
      list2:[],//下面两个文章分类
      list3:[],//下面右边的一个文章分类
      cindex_list:-1,//列表1 列表选项
      cindex_list2:-1,//列表2 列表选项
      cindex_list3:-1,//列表3 列表选项
      cindex_list4:-1,//列表4 列表选项
      cindex_list5:-1,//列表4 列表选项
      kuaisuList:[],//快速通道
      // carouseBottom:[],//底部跑马灯
      kuaisuIndex:1,
      organ_id:'',
      fenleiList:[],//首页5个分类
      redianList:[],//热点推荐列表
      pingmuWidth:0,
    }
  },
  methods:{
    //MarK:字数限制，超出不显示,num字数限制
    fontNumber (date,num) {
      const length = date.length
      if (length > num) {
        var str = ''
        str = date.substring(0, num) + '...'
        return str
      } else {
        return date
      }
    },
    // Mark:轮播图点击
    slideClick(obj){
      if(obj.type_id < 2){//外链
        window.open(obj.wailian,"_blank");
      }else if(obj.type_id == 2){//分类
        this.$router.push({name:'menulist',query:{id:obj.cate_id,index:-1,isShow:false}});//isShow:true文章详情 false列表
      }else{//文章
        this.$router.push({name:'menulist',query:{article_id:obj.article_id,id:obj.wz_cate_id,index:-1,isShow:true}});//isShow:true文章详情 false列表
      }
    },
    // Mark:快速通道点击
    goFast(obj){
      if(obj.type>1){//文章
          this.$router.push({name:'menulist',query:{article_id:obj.article_id,id:obj.wz_cate_id,index:-1,isShow:true}});//isShow:true文章详情 false列表
      }else{//分类
          this.$router.push({name:'menulist',query:{id:obj.ErjiId,index:-1,isShow:false}});//isShow:true文章详情 false列表
      }
    },
    change_list(index2,index) {
      if(index ==0){
        this.cindex_list = index2;
      }if(index ==1){
        this.cindex_list2 = index2;
      }
    },
    change_list2(index2,index) {
      if(index ==0){
        this.cindex_list3 = index2;
      }if(index ==1){
        this.cindex_list4 = index2;
      }
    },
    change_list3(index2,index) {
      if(index ==0){
        this.cindex_list5 = index2;
      }
    },
    // Mark:跳转文章详情
    goDetail(article_id,LanmuId){
       this.$router.push({name:'menulist',query:{article_id:article_id,id:LanmuId,index:-1,isShow:true}});//isShow:true文章详情 false列表
    },
    // Mark:跳转更多
    goMenuList(LanmuId){
     this.$router.push({name:'menulist',query:{id:LanmuId,index:-1,isShow:false}});//isShow:true文章详情 false列表
    },
    //Mark:热点推荐文章跳转 动态修改地址栏参数
    goDetail2(article_id){
      this.$router.push({name:'menulist',query:{article_id:article_id,id:108,index:-1,isShow:true,'isRedian':true}});//isShow:true文章详情 false列表
      //一级分类id,在首页的热点推荐进文章，没有一级分类，默认跳转10
      // this.$router.push({
        //     query:{
        //         article_id:article_id,
        //         id:10,
        //         index:-1,
        //         isShow:true,
        //     }
        // })
    },
    getData(){
      this.spinShow=true;
      // 上轮播图 
      xxShouYeLunBo({organ_id:this.organ_id}).then(res=>{
        if(res.data.code){
          for(let i =0;i<res.data.data.length;i++){
              if(res.data.data[i].location_id ==1){
                this.carouselTop.push(res.data.data[i]); //1.上轮播
              }else if(res.data.data[i].location_id == 2){//2.中轮播 去掉了
              }else if(res.data.data[i].location_id == 3){
                this.carouseBottom.push(res.data.data[i]); //3.下轮播
              }
          }
          // this.carouseBottom = this.carouseBottom.slice(0, 12);
          // this.carouseBottom =this.carouseBottom .reverse()//翻转
          
          let arr=this.carouseBottom;
          let carouse=[]
          for(let i=0;i<50;i++){
            for(let j=0;j<arr.length;j++){
              carouse.push(arr[j]);
            }
          }
          this.carouseBottom=carouse;
          this.spinShow=false;
          

            this.$nextTick(() => {
              goCarousel('roll')
            })
        }
      })
      // 首页分类
      xxShouYeArticle({organ_id:this.organ_id}).then(res=>{
          if(res.data.code){
              this.fenleiList=res.data.data;
              for(let i =0;i<res.data.data.length;i++){
                if(i==0 || i==1){
                    this.list1.push(res.data.data[i])
                }else if(i==2 || i==3){
                    this.list2.push(res.data.data[i])
                }else if(i==4){
                    this.list3.push(res.data.data[i])
                }
              }
          }
      })
      // 快速分类,最多显示6个
      xxFastChannel({organ_id:this.organ_id}).then(res=>{
        for(let i =0;i<res.data.data.length;i++){
          if(i<=5){
            this.kuaisuList.push(res.data.data[i]);
          }
        }
      })
      //热点推荐列表
      let data ={'organ_id':this.organ_id,};
      redianArticleList(data).then(res => {
          if (res.data.code == 1) {
              this.redianList = res.data.data;
          } else {
              this.$Message.info(res.data.msg)
          }
      })
    },
    
  },
  mounted(){
    this.organ_id=this.GLOBAL.organ_id;
    document.title ='沁阳市第一中学'
    this.pingmuWidth=document.body.clientWidth
    this.getData();
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  created(){
    this.organ_id=this.GLOBAL.organ_id;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    setTimeout(()=>{
        this.cindex_list=-1;
        this.cindex_list2=-1;
        this.cindex_list3=-1;
        this.cindex_list4=-1;
        this.cindex_list5=-1;
    },500)
  }
}
</script>
<style lang="less">
.lunbo_img_app{width:100%;height:auto}
.lunbo_img{cursor: pointer;width:1423px;height:333px}
  .con {
	  color: #6e6e6e;
		display: flex;
    font-size: 16px;
    margin-top:12px;
	}
	.con div {
    // width:300px;
    padding-right: 25px;
    padding-left: 20px;
    // margin-left: 20px;
		text-align: left;
		padding-bottom: 2px;
    color: #165b92;
    border-bottom: 2px solid #165b92;
    font-weight: bold;
	}
  .gengduo{
    color:#165b92;
    font-size:15px;
    margin-top:12px;
    font-weight:bold;
    cursor: pointer;
    margin-right:25px
  }
  .lineSty{
		border-top: solid #E8E8E8 1px;
		width: 100%;
		margin: 0px 0 16px 0;
  }
  .titleContainer-app{
        margin-top: 12px;
        color: #515a6e;
        .title{
          overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
          font-size: 15px;
          display: flex;
        }
        .tileTime{
          text-align: right;
        }
      }
  .titleContainer{
        cursor:pointer;
        margin-top: 11px;
        .title{
          // overflow:hidden;
          text-overflow:ellipsis;
          white-space:nowrap;
          font-size: 15px;
          display: flex;
        }
        .tileTime{
          text-align: right;
        }
      }
      .titleContainer:hover{
        color:#115c98;
        font-weight: bold;
      }
      // .titleContainer > .ivu-poptip > .ivu-poptip-rel{
      // }
      // .ivu-poptip{
      // }
.big_circle{
  margin-top:7px;
  border:2px solid #165b92;
  width:8px;
  height:8px;
  background-color:#fff;
  margin-right:5px
}
.small_circle{
  margin:8px 6px 0 3px;
  width:4px;
  height:4px;
  background-color:#165b92;
}
.topImg{
  width:20px;
  height:14px
}
.exprssCon div:hover{
	   color: #fff;
	   background-color: #c70000;
     border: solid #c70000 1px;
	}
.exprssCon{
  margin-bottom: 10px;
}
.exprssCon:nth-child(1) , .exprssCon:nth-child(2){
  margin-top:5px;
}
.exprss{
  text-align: center;
  padding:10px 0;
  font-size: 20px;
  background-color: #fff;
  color: #115c98;
  cursor: pointer;
  font-family: '黑体';
  font-weight: bold;
  border: solid #115c98 1px;
  border-radius: 5px;
}



.exprssCon-app div{
	   color: #fff;
	   background-color: #c70000;
     border: solid #c70000 1px;
	}
.exprssCon-app{
  margin-bottom: 10px;
}
// .exprssCon-app:nth-child(1) , .exprssCon:nth-child(2){
//   margin-top:5px;
// }
.exprss-app{
  text-align: center;
  padding:10px 0;
  font-size: 20px;
  background-color: #fff;
  color: #115c98;
  cursor: pointer;
  font-family: '黑体';
  font-weight: bold;
  border: solid #115c98 1px;
  border-radius: 5px;
}
</style>